import { Image, Circle, HStack, IconButton, Center } from '@chakra-ui/react';
// import { FavoriteBorderOutlined, SearchOutlined } from '@material-ui/icons';
import cogoToast from 'cogo-toast';
import {
  AiOutlineHeart,
  AiOutlineSearch,
  AiOutlineShoppingCart,
} from 'react-icons/ai';
import { useCtx } from '../context/AppContext';

// const Container = styled.div`
//   flex: 1;
//   margin: 5px;
//   min-width: 250px;
//   height: 350px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background-color: #f5fafd;
//   position: relative;

const Product = ({ item }) => {
  const { addCartItem, cartIds } = useCtx();
  return (
    <Center minW="250px" h="350px" bg="#f5fafd" pos={'relative'} rounded="lg">
      <Circle w="200px" h="200px" bg="white" pos="absolute" />
      <Image objectFit={'contain'} h="75%" w="full" zIndex={2} src={item.img} />
      <HStack
        rounded="lg"
        justifyContent={'center'}
        opacity="0"
        _hover={{
          opacity: 1,
        }}
        w="full"
        h="full"
        pos="absolute"
        top="0"
        left="0"
        zIndex={3}
        bg="rgba(0, 128, 128, 0.2)"
        transition="all 1s ease"
        cursor={'pointer'}
        spacing="5"
      >
        <IconButton
          rounded="full"
          fontSize="30px"
          w="40px"
          h="40px"
          bg="white"
          transition={'all 0.4s ease'}
          _hover={{
            background: 'teal',
            transform: 'scale(1.1)',
            color: 'white',
          }}
          onClick={() => {
            cartIds.includes(item.id)
              ? cogoToast.error('already added', { position: 'bottom-right' })
              : addCartItem(item);
          }}
          icon={<AiOutlineShoppingCart />}
        />
        <IconButton
          rounded="full"
          fontSize="30px"
          w="40px"
          h="40px"
          bg="white"
          transition={'all 0.4s ease'}
          _hover={{
            background: 'teal',
            transform: 'scale(1.1)',
            color: 'white',
          }}
          icon={<AiOutlineSearch />}
        />
        <IconButton
          rounded="full"
          fontSize="30px"
          w="40px"
          h="40px"
          bg="white"
          transition={'all 0.4s ease'}
          _hover={{
            background: 'teal',
            transform: 'scale(1.1)',
            color: 'white',
          }}
          icon={<AiOutlineHeart />}
        />
      </HStack>
    </Center>
  );
};

export default Product;
